import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { cx } from "@ghostwatch/ui";
import { AlertsPage, AssetsPage, ChecksPage, IncidentsPage, LoginPage } from "./pages";
import { useSession } from "./session";

const NAV = [
  { to: "/assets", label: "Assets" },
  { to: "/checks", label: "Checks" },
  { to: "/alerts", label: "Alerts" },
  { to: "/incidents", label: "Incidents" },
];

export default function App() {
  const { token, email, logout } = useSession();

  // Unauthenticated: the console is a single locked door, not a shell with empty
  // panels — rendering the chrome first would imply data that isn't there.
  if (!token) return <LoginPage />;

  return (
    <div className="min-h-full">
      <header className="flex items-center gap-6 border-b border-[var(--border)] bg-[var(--panel)] px-5 py-2.5">
        <span className="text-sm font-semibold tracking-wide">GhostWatch</span>
        <nav className="flex gap-1" aria-label="Main">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                cx(
                  "rounded px-2.5 py-1 text-sm transition-colors",
                  isActive
                    ? "bg-[var(--panel-2)] text-[var(--text)]"
                    : "text-[var(--text-dim)] hover:text-[var(--text)]",
                )
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-3 text-xs text-[var(--text-dim)]">
          <span>{email}</span>
          <button
            type="button"
            onClick={logout}
            className="rounded border border-[var(--border)] px-2 py-1 hover:text-[var(--text)]"
          >
            Sign out
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-6xl space-y-4 p-5">
        <Routes>
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/checks" element={<ChecksPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/incidents" element={<IncidentsPage />} />
          <Route path="*" element={<Navigate to="/assets" replace />} />
        </Routes>
      </main>
    </div>
  );
}
